export const ExperimentNames = {
  // Forever experiment
  UseWarmupState: 'specs.events.ui.UseWarmupState',
  EventDetailsSlots: 'specs.events.ui.EventDetailsSlots',
  EventDetailsSlotsViewer: 'specs.events.ui.EventDetailsSlotsViewer',
  DashboardSlots: 'specs.events.ui.DashboardSlots',
  ExpressCheckout: 'specs.events.ui.ExpressCheckout',
  UpdatePaymentMethodEnabled: 'specs.events.ui.UpdatePaymentMethodEnabled', // Disables fees on offline payment, disable to prevent order update on paymentMethod change.

  SausageIntegration: 'specs.events.ui.SausageIntegration', // false 100%, 2024-11-08
  UpdatePaymentTermsPaypal: 'specs.events.ui.UpdatePaymentTermsPaypal',
  AiEventsAssistantV2: 'specs.events.ui.AiEventsAssistantV2',
  AiEventsQaAssistant: 'specs.events.ui.AiEventsQaAssistant',
  AiTicketsAssistant: 'specs.events.ui.AiTicketsAssistant',
  AiTicketsQaAssistant: 'specs.events.ui.AiTicketsQaAssistant',

  AiEventsListQaAssistant: 'specs.events.ui.AiEventsListQaAssistant',
  AiChangeEventTypeAssistant: 'specs.events.ui.AiChangeEventTypeAssistant',
  AiOnlineEventQaAssistant: 'specs.events.ui.AiOnlineEventQaAssistant',
  AiDetailsPageStyleQaAssistant: 'specs.events.ui.AiDetailsPageStyleQaAssistant',
  AiCheckInAppQaAssistant: 'specs.events.ui.AiCheckInAppQaAssistant',
  AiAddStaffMemberAssistant: 'specs.events.ui.AiAddStaffMemberAssistant',

  ServerlessWidgetData: 'specs.events.ui.ServerlessWidgetData',
  CurvedMultiRowAnnouncement: 'specs.seatings.ui.CurvedMultiRowAnnouncement',
  AutomationV3Enabled: 'automations.SiteOnV3AutomationsBuilder',
  OfferExpressCheckout: 'specs.events.ui.OfferExpressCheckout',
  CategoryMenuSettings: 'specs.events.ui.CategoryMenuSettings',
  DelayedPayments: 'specs.events.ui.DelayedPaymentCapture',
  AutomationsBanner: 'specs.events.ui.AutomationsBanner',
  AiCopyTicketsAssistant: 'specs.events.ui.AiCopyTicketsAssistant',
  SkillTicketPolicy: 'specs.events.ui.SkillTicketPolicy',
  ImageRatioAssistant: 'specs.events.ui.ImageRatioAssistant',
  AiCreateCategoryAssistant: 'specs.events.ui.AiCreateCategoryAssistant',
  AiCategoriesQaAssistant: 'specs.events.ui.AiCategoriesQaAssistant',
  SkillMembershipsQA: 'specs.events.ui.SkillMembershipsQA',
  AiGuestsAndOrdersQaAssistant: 'specs.events.ui.AiGuestsAndOrdersQaAssistant',
  AiCreateScheduleItemAssistant: 'specs.events.ui.AiCreateScheduleItemAssistant',
  AiCreateRegistrationFormFieldAssistant: 'specs.events.ui.AiCreateRegistrationFormFieldAssistant',
  AiPromotionsAssistant: 'specs.events.ui.PromotionsAssistantQA',
  SkillSeatingQA: 'specs.seatings.ui.SkillSeatingQA',
  FeaturedEventWidget: 'specs.events.ui.FeaturedEventWidget',
  DisableRicosImageGeneration: 'specs.events.ui.DisableRicosImageGeneration',
  UpdatedDisplayListEventsPanel: 'specs.events.ui.UpdatedDisplayListEventsPanel',
  NewClassicEvents: 'se_eventsCategoryNewContentInAddPanel', // Add panel
  UpdateRichContentTruncate: 'specs.events.ui.UpdateRichContentTruncate',
  HideWidgetTypeSelect: 'specs.events.ui.HideWidgetTypeSelect',
  BulkGuestRemove: 'specs.events.ui.BulkGuestRemove',
  UpdateTicketedGuestPrice: 'specs.events.ui.UpdateTicketedGuestPrice',
  SoldSeatsOnLoadWarning: 'specs.seatings.ui.SoldSeatsOnLoadWarning',
  NewCreateEventImageCard: 'specs.events.ui.NewCreateEventImageCard',
  DelayPaymentModalLocalization: 'specs.events.ui.DelayPaymentModalLocalization',
  StaffReadGuestFormPermission: 'specs.events.ui.StaffReadGuestFormPermission',
  DuplicateTicketFromSeatings: 'specs.events.ui.DuplicateTicketFromSeatings',
  ViewContactEntryPoints: 'specs.events.ui.ViewContactEntryPoints',
  RenameTicketPolicyAI: 'specs.events.ui.RenameTicketPolicyAI',
  RelocatedPoliciesModal: 'specs.events.ui.RelocatedPoliciesModal',
  RelocatedOccurrencesModal: 'specs.events.ui.RelocatedOccurrencesModal',
  AssignTicketsOccupiedSeats: 'specs.events.ui.AssignTicketsOccupiedSeats',
  RelocatedUpgradeModal: 'specs.events.ui.RelocatedUpgradeModal',
  VistaprintEntryPoint: 'specs.events.ui.VistaprintEntryPoint',
  RelocatedPagesModal: 'specs.events.ui.RelocatedPagesModal',
  RelocatedPageInfo: 'specs.events.ui.RelocatedPageInfo',
  RelocatedGoogleMap: 'specs.events.ui.RelocatedGoogleMap',
  FixLoadMembers: 'specs.events.ui.FixLoadMembers',
  ButtonLayoutEmptyState: 'specs.events.ui.ButtonLayoutEmptyState',
  RestrictPaymentSettings: 'specs.events.ui.RestrictPaymentSettings',
  EmailsForManuallyAddedRsvps: 'specs.events.ui.EmailsForManuallyAddedRsvps',
  NavigateToEcomCheckout: 'specs.events.ui.NavigateToEcomCheckout',
  PublishSiteBanners: 'specs.events.ui.PublishSiteBanners',
  UseAmbassadorForAddSeatedGuestsManually: 'specs.events.ui.UseAmbassadorForAddSeatedGuestsManually',
  UseAmbassadorForAddGuestsManually: 'specs.events.ui.UseAmbassadorForAddGuestsManually',
  FixDetailsPageInitialNavigation: 'specs.events.ui.FixDetailsPageInitialNavigation',
  CalendarRevamp: 'specs.events.ui.CalendarRevamp',
  UseWixForms: 'specs.events.ui.useWixForms',
  MPANavigation: 'specs.events.ui.MPANavigation',
  WidgetRsvpButtonHoverColor: 'specs.events.ui.WidgetRsvpButtonHoverColor',
  CheckoutSummaryFromReservation: 'specs.events.ui.CheckoutSummaryFromReservation',
  MobileCalendarRewire: 'specs.events.ui.MobileCalendarRewire',
  UseWixFormsComposer: 'specs.events.ui.useWixFormsComposer',
}
